import BaseSessionStorageState from './base-session-storage-state';

export const KEYS = {
  CATEGORY: 'category',
  SHOW_MORE_FILTERS: 'showMoreFilters',
  SEARCH: 'search'
};

class ServicesFilterState extends BaseSessionStorageState {
  constructor($log, $sessionStorage) {
    super($log, $sessionStorage)
    this.storageName = 'savedServices';
    const initialState = Object.assign(this.getDefaults(), $sessionStorage[this.storageName]);
    this.$sessionStorage[this.storageName] = initialState;
  }

  getDefaults() {
    return {
      search: "",
      category: 0,
      showMoreFilters: false
    }
  }
}

export default ServicesFilterState;
